import React, { useEffect } from "react";
import AllergenView from "../components/Allergens/AllergenView";
import { useParams } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { List, Paper, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { useDialog } from "../components/Dialogs/DialogProvider";
import { getAllergens, updateAllergens } from "../store/AllergenApi";
import { allergens as defaultAllergens } from "../utils/Allergens";
import { CreateAllergen } from "../store/articles/models/Allergen";
import CreateAllergenView from "../components/Allergens/CreateAllergenView";

function Allergens() {
  const merchantId = Number.parseInt(useParams().merchantId);
  const [allergens, setAllergens] = React.useState(null);
  const [openDialog, closeDialog] = useDialog();

  const refreshAllergens = () => {
    getAllergens(merchantId).then((allergens) => {
      let newAllergens = { ...defaultAllergens };
      allergens.forEach((allergen) => {
        newAllergens[allergen.id] = CreateAllergen(allergen);
      });
      setAllergens(newAllergens);
    });
  };

  useEffect(() => {
    refreshAllergens();
  }, []);

  if (!allergens) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <Paper style={{ display: "flex", flexFlow: "wrap", flexDirection: "column" }}>
      <Typography variant={"h6"}>Labels</Typography>
      <div>
        <Button
          color={"primary"}
          onClick={() => {
            openDialog({
              children: (
                <CreateAllergenView
                  onSave={(allergen) => {
                    updateAllergens(merchantId, [null], [allergen], []).then((allergen) => {
                      closeDialog();
                      refreshAllergens();
                    });
                  }}
                />
              ),
            });
          }}
          variant={"outlined"}
        >
          New
        </Button>
      </div>
      <List>
        {Object.keys(allergens).map((allergenId) => {
          return <AllergenView merchantId={merchantId} allergen={allergens[allergenId]} />;
        })}
      </List>
    </Paper>
  );
}

export default Allergens;
